const appConfig = {
  authenticatedEntryPath: "/root",
  unAuthenticatedEntryPath: "/home",
  tourPath: "",
  enableMock: false,
};

export default appConfig;
